import React, { useEffect } from 'react'
import { useState } from 'react'
import TableView from '../components/TableViews/TableView'
import axios from 'axios';
import { useSelector } from 'react-redux';
import PopUpModal from '../../client/components/PopupModal';
import EditStore from './EditStore';
import LoadingScreen from '../components/LoadingScreen/LoadingScreen';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ReactSelect from 'react-select';

export default function Settings() {
    const [stores, setStores] = useState([]);
    const { user } = useSelector((state) => state.auth);
    const sellerId = user.seller_profile_id;
    const [editModal, setEditModal] = useState(false);
    const [type, setType] = useState([]);
    const [id, setId] = useState(-1);
    const [search, setSearch] = useState("");
    const [typeFilter, setTypeFilter] = useState();
    const [orderBy, setOrderBy] = useState({ created_at: 'DESC' })

    const handleTypeFilter = (e)=> {
        setTypeFilter(e.value)
    }

    const [toggle, refreshPage] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const DELAY_TIME = 1500;
    const edit = (id) => {
        setEditModal(true);
        setId(id)
    }

    const closeModalEdit = () => {
        setEditModal(false);
        setId(-1)
    }

    const remove = (id) => {
        axios.delete(process.env.REACT_APP_FIND_API_URL + '/store/delete-store/' + id, {withCredentials: true}).then(() => {
            refreshPage(prev => !prev)
        })
    }

    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            let filters = {}
            if(typeFilter !== ''){
                filters['seller_store_register.seller_type_id'] = typeFilter;
            }
            if(search?.length > 0){
                filters['seller_store_name'] = search;
            }
            axios.post(process.env.REACT_APP_FIND_API_URL + `/store/get-stores/${sellerId}`, {filters: filters, orderBy: orderBy}, {withCredentials: true}).then((res) => {
                setStores(res.data);
                setIsLoading(false)
            })
        }, DELAY_TIME);
        return () => {
            clearTimeout(pageTimeout);
        }
    }, [typeFilter ,sellerId, toggle, search,orderBy]);

    useEffect(()=> {
        axios.get(process.env.REACT_APP_FIND_API_URL + '/seller-type/get', {withCredentials: true}).then((res)=> {
            const getTypes = res.data.map((t)=> ({value: t.seller_type_id, label: t.seller_type_name}))
            setType(getTypes);
        })
    }, [])

    return (
        <>
        {
            isLoading ? (
                <LoadingScreen />
            ) : ( <>
                <Container fluid>
                    <Row className='mb-5'>
                        <Col md="3">
                            <div className="topnav__search">
                                <input type="text" placeholder='Search here...' onChange={(e)=> setSearch(e.target.value)} />
                                <i className='bx bx-search'></i>
                            </div>
                        </Col>
                        <Col md="3"></Col>
                        <Col md="3">
                            <ReactSelect options={type} onChange={(e)=> handleTypeFilter(e)} />
                        </Col>
                        <Col md="3" className='text-end'>
                            <Link to='/sell-on-findNow'>
                                <Button>Add Store +</Button>
                            </Link>
                        </Col>
                    </Row>
                    <TableView 
                        data={stores} 
                        edit={edit} 
                        remove={remove}
                        columnNotShow={['id']}
                        dateColumn={['created_at']}
                        sortColumn={['store_name', 'created_at']}
                        orderBy={orderBy}
                        setOrderBy={setOrderBy} 
                    />
                </Container>
                </>
            )
        }
            <PopUpModal title="Edit Store" show={editModal} onHide={closeModalEdit}>
                <EditStore id={id} close={closeModalEdit} />
            </PopUpModal>
        </>
    )
}